import { Button, Col, Row } from "react-bootstrap";

interface IDetailFooterProps {
    hasFormDataChanged: boolean;
    deleteAsync: () => void;
    submitFormAsync: () => void;
    dontAllowSavingChanges?: boolean;
}

const DetailFooter = (props: IDetailFooterProps) => {
    return (
        <>
            <Row style={{ position: "relative", height: "50px" }}>
                <Row
                    className="align-items-end border rounded"
                    style={{
                        position: "fixed",
                        bottom: "20px",
                        left: "20px",
                        width: "100vw",
                        padding: "10px",
                        backgroundColor:
                            props.hasFormDataChanged ?
                                "rgba(255, 0, 0, 0.3)" :
                                "rgba(255, 255, 255, 0.8)"
                    }}>
                    <Col>
                        <Button
                            style={{ width: "100%" }}
                            variant="danger"
                            onClick={
                                () => props.deleteAsync()}>Delete</Button>
                    </Col>
                    <Col>
                        <Button
                            disabled={props.dontAllowSavingChanges}
                            style={{ width: "100%" }}
                            onClick={
                                () => props.submitFormAsync()}>Save Changes</Button>
                    </Col>
                </Row>
            </Row>
        </>
    );
}

export default DetailFooter;